// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/cjs.js!../../../../shared/responsive-variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Responsive Variables */

/*
 * Global box-sizing reset.
 *
 * Without this, \`width: 100%\` + any padding overflows the parent by
 * exactly the padding amount — which is why the doc-manager tag panel
 * and content pane were being clipped at the right edge on mobile
 * despite explicit width:100% + overflow-x:hidden protection.
 *
 * Standard modern-CSS practice; unifies every child element's box
 * accounting so \`width\` and \`max-width\` mean the actual outer box.
 */
*,
*::before,
*::after {
  box-sizing: border-box;
}

.layout {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
  position: relative;
}

.layout-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
}

.layout-content {
  flex: 1;
  padding: var(--mobile-padding);
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

/* Mobile overlay for sidebar */
.layout-overlay {
  display: none;
}

/* Tablet and up */
@media (min-width: 768px) {
  .layout-content {
    padding: 24px;
  }
}

/* Mobile: Show overlay when menu is open */
@media (max-width: 767px) {
  .layout-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: var(--z-mobile-overlay);
    animation: fadeIn 0.2s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Prevent iOS Safari from zooming into inputs on focus.
     Safari zooms whenever the input's font-size is < 16px; this bumps
     every text-y input on mobile only, so desktop styling is unchanged.
     Applied globally here so per-component CSS doesn't have to remember. */
  input[type="text"],
  input[type="search"],
  input[type="email"],
  input[type="password"],
  input[type="number"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input:not([type]),
  textarea,
  select {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAGhC;;;;;;;;;;EAUE;AACF;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,gCAAgC;IAChC,+BAA+B;EACjC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;;;2EAGyE;EACzE;;;;;;;;;;;;;IAaE,eAAe;EACjB;AACF","sourcesContent":["/* Import Responsive Variables */\n@import '../../../../shared/responsive-variables.css';\n\n/*\n * Global box-sizing reset.\n *\n * Without this, `width: 100%` + any padding overflows the parent by\n * exactly the padding amount — which is why the doc-manager tag panel\n * and content pane were being clipped at the right edge on mobile\n * despite explicit width:100% + overflow-x:hidden protection.\n *\n * Standard modern-CSS practice; unifies every child element's box\n * accounting so `width` and `max-width` mean the actual outer box.\n */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n.layout {\n  display: flex;\n  min-height: 100vh;\n  background: #f8fafc;\n  position: relative;\n}\n\n.layout-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  width: 100%;\n}\n\n.layout-content {\n  flex: 1;\n  padding: var(--mobile-padding);\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* Mobile overlay for sidebar */\n.layout-overlay {\n  display: none;\n}\n\n/* Tablet and up */\n@media (min-width: 768px) {\n  .layout-content {\n    padding: 24px;\n  }\n}\n\n/* Mobile: Show overlay when menu is open */\n@media (max-width: 767px) {\n  .layout-overlay {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: var(--z-mobile-overlay);\n    animation: fadeIn 0.2s ease-out;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  /* Prevent iOS Safari from zooming into inputs on focus.\n     Safari zooms whenever the input's font-size is < 16px; this bumps\n     every text-y input on mobile only, so desktop styling is unchanged.\n     Applied globally here so per-component CSS doesn't have to remember. */\n  input[type=\"text\"],\n  input[type=\"search\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"number\"],\n  input[type=\"tel\"],\n  input[type=\"url\"],\n  input[type=\"date\"],\n  input[type=\"datetime-local\"],\n  input[type=\"time\"],\n  input:not([type]),\n  textarea,\n  select {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
